import { Opaque } from '@utils/opaque';

type InstagramHashtag = Opaque<string, 'InstagramHashtag'>;

function InstagramHashtagFactory(instagramHashtag: string) {
  return instagramHashtag as InstagramHashtag;
}

const InstagramHashtag = InstagramHashtagFactory;

export default InstagramHashtag;
